// RKS Technologies - Mock Data

export const companyInfo = {
  name: "RKS Technologies",
  tagline: "IT Consulting & Staffing Solutions",
  slogan: "We connect top IT talent with organizations that need immediate results.",
  email: "info@rkstechnologiespa.com",
  phone: "(832) 343-0192",
  location: "Mechanicsburg, PA, United States",
  hours: "Mon - Fri: 9:00 AM - 6:00 PM EST",
  year: 2025
};

export const navLinks = [
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "Industries", href: "#industries" },
  { name: "Process", href: "#process" },
  { name: "Careers", href: "#careers" },
  { name: "Contact", href: "#contact" }
];

export const aboutContent = {
  title: "Who We Are & How We Work",
  description: "RKS Technologies is an IT consulting and staffing firm helping organizations build high-performing technology teams. We source and place skilled IT professionals who deliver measurable results.",
  highlights: [
    "Integrity & Transparency in every engagement",
    "Excellence & Innovation in talent matching",
    "Commitment to long-term partnerships",
    "Results-driven staffing solutions"
  ]
};

export const services = [
  {
    id: 1,
    title: "IT Staffing Solutions",
    description: "Pre-vetted engineers ready to deploy. Scale teams in days, not months.",
    outcome: "Reduce hiring time by 40%",
    icon: "Users"
  },
  {
    id: 2,
    title: "IT Consulting Services",
    description: "Expert guidance for enterprise and startup technology initiatives.",
    outcome: "Strategic tech roadmap delivery",
    icon: "Lightbulb"
  },
  {
    id: 3,
    title: "Project-Based Teams",
    description: "End-to-end teams for specific project requirements with full accountability.",
    outcome: "Complete project ownership",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Quality Assurance",
    description: "Manual and automated QA ensuring performance, security, and reliability.",
    outcome: "Almost perfect defect-free delivery",
    icon: "ShieldCheck"
  }
];

export const staffingTypes = [
  {
    title: "Contract Staffing",
    description: "Flexible options for short-term and long-term projects."
  },
  {
    title: "Contract-to-Hire",
    description: "Evaluate talent before transitioning to permanent roles."
  },
  {
    title: "Direct Placement",
    description: "Full-time professionals aligned with your culture and needs."
  }
];

export const professionals = [
  "Software Developers (Java, .NET, Python, React)",
  "Business Analysts & Project Managers",
  "QA & Automation Engineers",
  "Data Analysts & Engineers",
  "DevOps & Cloud Engineers"
];

export const whyChooseUs = [
  { text: "Carefully vetted IT professionals", icon: "CheckCircle" },
  { text: "Fast turnaround — fill roles in days", icon: "Zap" },
  { text: "Skill & culture-fit matching", icon: "Target" },
  { text: "Dedicated support throughout", icon: "HeadphonesIcon" }
];

export const industries = [
  {
    id: 1,
    title: "Healthcare IT",
    description: "Compliant, secure, and efficient IT professionals for healthcare.",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Finance & FinTech",
    description: "Specialized talent for financial systems and compliance.",
    icon: "Landmark"
  },
  {
    id: 3,
    title: "Public Sector",
    description: "Experienced consultants for government IT modernization.",
    icon: "Building2"
  },
  {
    id: 4,
    title: "Technology & SaaS",
    description: "Rapid scaling with skilled engineers and architects.",
    icon: "Code2"
  }
];

export const hiringProcess = [
  {
    step: 1,
    title: "Understand Your Needs",
    description: "Define skills, experience, and objectives."
  },
  {
    step: 2,
    title: "Talent Sourcing",
    description: "Leverage our curated network for best candidates."
  },
  {
    step: 3,
    title: "Screening & Interview",
    description: "Technical evaluation and background checks."
  },
  {
    step: 4,
    title: "Deployment",
    description: "Smooth onboarding with ongoing support."
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "RKS helped us fill a critical DevOps role in under a week. Their speed and quality exceeded our expectations.",
    author: "Director of Engineering",
    company: "FinTech Startup"
  },
  {
    id: 2,
    quote: "Clear communication and high-quality candidates. We've made RKS our go-to staffing partner.",
    author: "VP of Technology",
    company: "Healthcare Company"
  },
  {
    id: 3,
    quote: "The team understood our technical requirements perfectly. Every candidate was interview-ready.",
    author: "CTO",
    company: "SaaS Platform"
  }
];

export const candidateBenefits = [
  "Access to top consulting clients",
  "Career growth opportunities",
  "Competitive compensation",
  "Flexible engagement models"
];

export const trustLogos = [
  "Fortune 500 Companies",
  "Healthcare Enterprises",
  "FinTech Innovators",
  "Government Agencies"
];

export const footerLinks = {
  quickLinks: [
    { name: "Home", href: "#hero" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Careers", href: "#careers" },
    { name: "Contact", href: "#contact" }
  ],
  legal: [
    { name: "Privacy Policy", href: "#" },
    { name: "Terms & Conditions", href: "#" }
  ]
};
